import { Component, EventEmitter, OnInit, Output} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { startWith, debounceTime, switchMap, tap, finalize } from 'rxjs/operators';
import { CompanyFound } from "../../models/CompanyFound.model";
import { CompanySearched } from "../../models/CompanySearched.model";
import { DqeService } from "../../models/dqe.service";

@Component({
    selector: 'search-company',
    templateUrl: './search-company.component.html',
    styleUrls: ['./search-company.component.scss']
})
export class SearchCompany implements OnInit {
    searchString: string = "";
    filteredResearch: CompanySearched[];
    researchField: UntypedFormControl = new UntypedFormControl();
    isLoading = false;
    companyIsLoading = false;

    @Output() company = new EventEmitter<CompanyFound|null>();

    constructor(private dqeService: DqeService) {}

    ngOnInit(): void {
        this.researchField.valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                tap(() => {
                this.isLoading = true;
                this.filteredResearch = [];
                }),
                switchMap(value => value && value.length > 1 && !/_([0-9]*)/.test(value.trim()) ? this.dqeService.searchCompany(value).pipe(
                finalize(() => {
                    this.isLoading = false;
                })
                ) :[])
            ).subscribe( (data: CompanySearched[]) => {
                if (data && data.slice) {
                    this.filteredResearch = data.slice(0, 10);
                }
            });
    }

    companyChosen($event: MatAutocompleteSelectedEvent) {
        if (!$event.option.value || $event.option.value === '') {
          return;
        }
        this.company.emit(null);
        this.companyIsLoading = true;
        this.dqeService.searchCompanyInfo($event.option.value).subscribe((company: CompanyFound) => {
            this.researchField.patchValue('');
            this.company.emit(company);
            this.companyIsLoading = false;
        });
    }

    displayCompleteOption(id: string) {
        if (!id) {
          return '';
        }
        const index = this.filteredResearch.findIndex(option => option.searchReference === id);
        return this.filteredResearch[index].name;
    }
}